import { AppSetting } from '../AppSetting';
import { AppSettingApi } from '../AppSettingApi';
import { BaseService } from '../Service/BaseService';
import { BaseWebApiDAO } from './BaseWebApiDAO';
import { MailTemplateDTOInterface } from '../DTO/MailTemplateDTOInterface';
import {MailTemplateCategoryDTOInterface} from '../DTO/MailTemplateCategoryDTOInterface';


/**
 * MessageTemplateDAO
 * メールテンプレートDAO
 */
export class MessageTemplateDAO extends BaseWebApiDAO {

	/**
	 * constructor
	 */
	constructor(svc: BaseService) {
		super(svc);
	}

	/**
	 * getMailTemplateList
	 * メールテンプレート一覧を取得。
	 * @return Promise<any>
	 */
	public async getMailTemplateList(): Promise<Array<any>> {

		// リクエスト作成
		const request = {
			t: this.token
		};

		// リクエスト実行。エラーは中で用意される。
		const res = await this.postRequest(AppSettingApi.MESSAGE_TEMPLATE_LIST, request);
		return res;

	}


	/**
	 * getMailTemplateList
	 * メールテンプレートを取得。
	 * @param id メールテンプレートID
	 * @return Promise<any>
	 */
	public async getMailTemplate(id: number): Promise<any> {
		this.log('MessageTemplateDAO::getMailTemplate()');
		// デバッグモードならダミーを返す
		if (AppSetting.DEBUG_MODE_DUMYDATA) {
			return '';
		}

		// リクエスト作成
		const request = {
			t: this.token,
			id
		};

		this.log(AppSettingApi.MESSAGE_TEMPLATE_DETAIL);
		this.log(request);
		// リクエスト実行。エラーは中で用意される。
		const res = await this.postRequest(AppSettingApi.MESSAGE_TEMPLATE_DETAIL, request);
		this.log(res);

		return res;

	}


	/**
	 * addMailTemplate
	 * @param name
	 * @param subject
	 * @param content
	 * @param mailTemplateCategory
	 */
	public async addMailTemplate(
		name: string,
		subject: string,
		content: string,
		mailTemplateCategory: Array<MailTemplateCategoryDTOInterface>
	): Promise<any> {

		// デバッグモードならダミーを返す
		if (AppSetting.DEBUG_MODE_DUMYDATA) {
			return '';
		}

		// リクエスト作成
		const request = {
			t: this.token,
			name,
			subject,
			content,
			mailTemplateCategory
		};

		// リクエスト実行。エラーは中で用意される。
		const res = await this.postRequest(AppSettingApi.MESSAGE_TEMPLATE_CREATE, request);
		return res;

	}


	/**
	 * editMailTemplate
	 * @return Promise<any>
	 */
	public async editMailTemplate(
		id: number,
		name: string,
		subject: string,
		content: string,
		mailTemplateCategory: Array<MailTemplateCategoryDTOInterface>
	): Promise<any> {

		this.log('MessageTemplateDAO::editMailTemplate()');
		// デバッグモードならダミーを返す
		if (AppSetting.DEBUG_MODE_DUMYDATA) {
			return '';
		}

		// リクエスト作成
		const request = {
			t: this.token,
			id,
			name,
			subject,
			content,
			mailTemplateCategory
		};

		this.log(AppSettingApi.MESSAGE_TEMPLATE_EDIT);
		this.log(request);

		// リクエスト実行。エラーは中で用意される。
		const res = await this.postRequest(AppSettingApi.MESSAGE_TEMPLATE_EDIT, request);
		return res;

	}

	/**
	 * deleteMailTemplate
	 * メールテンプレートを削除。TODO: サーバ側。権限チェックで、編集してよい企業かチェックが必要。
	 * @param id メールテンプレートID
	 * @return Promise<any>
	 */
	public async deleteMailTemplate(id: number): Promise<any> {

		// デバッグモードならダミーを返す
		if (AppSetting.DEBUG_MODE_DUMYDATA) {
			return '';
		}

		// リクエスト作成
		const request = {
			t: this.token,
			id
		};

		// リクエスト実行。エラーは中で用意される。
		const res = await this.postRequest(AppSettingApi.MESSAGE_TEMPLATE_DELETE, request);
		return res;

	}

}
